/**
 * @fileoverview Program-attribution chip (Spec 12 WP1/WP3). Renders "{program}
 * · {org}" with an accent dot for a program-attributed lesson/occurrence.
 * Renders nothing for a solo lesson (no program_title).
 */

import { SCHEDULER_VIEW_ENABLED } from "@/lib/featureFlags";

export default function ProgramChip({ programTitle, orgName, accent, className = "", lesson }) {
  const context = SCHEDULER_VIEW_ENABLED && lesson ? (lesson.org_id || lesson.program_id
    ? (orgName && programTitle ? `${orgName} · ${programTitle}` : "Unassigned")
    : (lesson.scheduler_connection_id || lesson.scheduled_slot_id ? "Personal" : "Unassigned")) : null;
  if (!programTitle && !context) return null;
  const label = context || (orgName ? `${programTitle} · ${orgName}` : programTitle);
  const dot = accent || "var(--accent-yellow)";
  return (
    <span
      data-testid="program-chip"
      className={`inline-flex items-center gap-1.5 rounded-full border border-[var(--studio-divider-strong)] px-2 py-0.5 text-[11px] font-medium text-[var(--text-secondary)] ${className}`}
      title={label}
    >
      <span className="h-1.5 w-1.5 shrink-0 rounded-full" style={{ backgroundColor: dot }} />
      <span className="truncate">
        {label}
      </span>
    </span>
  );
}
